module.exports = __webpack_public_path__ + "static/media/contrato_planes_y_tarifas_ecommerce.901a4a81.pdf";